import { z } from "zod";

/**
 * 견적 문의 상태
 */
export const QuoteInquiryStatusSchema = z.enum(["PENDING", "REPLIED", "CLOSED"]);
export type QuoteInquiryStatus = z.infer<typeof QuoteInquiryStatusSchema>;

/**
 * 견적 문의 상태 라벨
 */
export const QuoteInquiryStatusLabels: Record<QuoteInquiryStatus, string> = {
  PENDING: "대기중",
  REPLIED: "답변완료",
  CLOSED: "종료",
};

/**
 * 견적 문의 상태 색상
 */
export const QuoteInquiryStatusColors: Record<
  QuoteInquiryStatus,
  { bg: string; text: string }
> = {
  PENDING: { bg: "#FEF3C7", text: "#D97706" },
  REPLIED: { bg: "#D1FAE5", text: "#059669" },
  CLOSED: { bg: "#E5E7EB", text: "#6B7280" },
};

/**
 * 견적 문의 목록 아이템
 */
export const QuoteInquiryListItemSchema = z.object({
  id: z.number(),
  productName: z.string().nullable().optional(),
  inquirerName: z.string(),
  inquirerEmail: z.string(),
  quantity: z.number(),
  status: QuoteInquiryStatusSchema,
  createdAt: z.string(),
  repliedAt: z.string().nullable().optional(),
});

export type QuoteInquiryListItem = z.infer<typeof QuoteInquiryListItemSchema>;

/**
 * 견적 문의 상세
 */
export const QuoteInquiryDetailSchema = z.object({
  id: z.number(),
  companyId: z.number(),
  productId: z.number().nullable().optional(),
  productName: z.string().nullable().optional(),
  userId: z.number().nullable().optional(),
  inquirerName: z.string(),
  inquirerEmail: z.string(),
  inquirerMobile: z.string().nullable().optional(),
  productOptionsSnapshot: z.string().nullable().optional(),
  quantity: z.number(),
  inquiryContent: z.string(),
  status: QuoteInquiryStatusSchema,
  replySubject: z.string().nullable().optional(),
  replyContent: z.string().nullable().optional(),
  repliedByName: z.string().nullable().optional(),
  repliedAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().nullable().optional(),
});

export type QuoteInquiryDetail = z.infer<typeof QuoteInquiryDetailSchema>;

/**
 * 견적 문의 생성 요청
 */
export interface CreateQuoteInquiryRequest {
  productId?: number;
  inquirerName: string;
  inquirerEmail: string;
  inquirerMobile?: string;
  productOptionsSnapshot?: string;
  quantity: number;
  inquiryContent: string;
}

/**
 * 견적 문의 답변 요청
 */
export interface ReplyQuoteInquiryRequest {
  replySubject: string;
  replyContent: string;
}

/**
 * 견적 문의 상태 변경 요청
 */
export interface UpdateQuoteInquiryStatusRequest {
  status: QuoteInquiryStatus;
}

/**
 * 견적 문의 목록 응답 (페이징)
 */
export interface QuoteInquiryPageResponse {
  content: QuoteInquiryListItem[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}
